<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="用户id，外键{user.id}" prop="userId" >-->
      <!--        <a-input v-model="form.userId" placeholder="请输入用户id，外键{user.id}" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="反馈类型：1-意见建议、2-故障报告、3-投诉" prop="type" >-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="反馈内容" prop="content" >-->
      <!--        <editor v-model="form.content" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('views.appFeedback.column.processStatus')" prop="processStatus" >
        <a-select v-model="form.processStatus" :placeholder="$t('views.appFeedback.query.processStatusPlaceholder')">
          <a-select-option :value="2">{{ $t('views.appFeedback.processStatus.done') }}</a-select-option>
          <a-select-option :value="3">{{ $t('views.appFeedback.processStatus.skipped') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        v-if="showReplyContent"
        :label="$t('views.appFeedback.column.processResult')"
        prop="processResult"
      >
        <a-input v-model="form.processResult" type="textarea" :placeholder="$t('views.appFeedback.form.processResultPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item
        v-if="showReplyContent"
        :label="$t('views.appFeedback.column.processResultEn')"
        prop="processResultEn"
      >
        <a-input v-model="form.processResultEn" type="textarea" :placeholder="$t('views.appFeedback.form.processResultEnPlaceholder')" />
      </a-form-model-item>
      <!--      <a-form-model-item label="反馈图片地址集合,JSONArray的字符串" prop="imgUrls" >-->
      <!--        <a-input v-model="form.imgUrls" placeholder="请输入反馈图片地址集合,JSONArray的字符串" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="联系方式" prop="contact" >-->
      <!--        <a-input v-model="form.contact" placeholder="请输入联系方式" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入备注" />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.appFeedback.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.appFeedback.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getFeedback, addFeedback, updateFeedback } from '@/api/app/feedback'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        content: null,

        processStatus: 2,

        processResult: null,

        processResultEn: null,

        imgUrls: null,

        contact: null,

        remark: null,

        createTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户id，外键{user.id}不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    /** 仅「已回复」时展示回复内容字段 */
    showReplyContent () {
      return Number(this.form.processStatus) === 2
    }
  },
  watch: {
    'form.processStatus' (val) {
      if (Number(val) === 3) {
        this.form.processResult = null
        this.form.processResultEn = null
      }
    }
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        content: null,
        processStatus: 2,
        processResult: null,
        processResultEn: null,
        imgUrls: null,
        contact: null,
        remark: null,
        createTime: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.appFeedback.title.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getFeedback({ 'id': id }).then(response => {
        const d = response.data || {}
        const rawStatus = d.processStatus != null && d.processStatus !== '' ? Number(d.processStatus) : null
        // 待回复(1) 打开时默认已回复(2)；暂不回复(3) 保留
        const processStatus = rawStatus === 3 ? 3 : 2
        this.form = {
          ...d,
          processStatus,
          processResultEn: d.processResultEn != null && d.processResultEn !== '' ? d.processResultEn : d.process_result_en
        }
        if (this.form.process_result_en !== undefined) {
          delete this.form.process_result_en
        }
        this.open = true
        this.formTitle = this.$t('views.appFeedback.title.replyAudit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            const payload = { ...this.form }
            if (Number(payload.processStatus) === 3) {
              payload.processResult = null
              payload.processResultEn = null
            }
            updateFeedback(payload).then(response => {
              this.$message.success(
                this.$t('views.appFeedback.msg.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addFeedback(this.form).then(response => {
              this.$message.success(
                this.$t('views.appFeedback.msg.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
